export { FeaturedProducts } from './FeaturedProducts'
export type { FeaturedProductsProps } from './FeaturedProducts'
